import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { shadowOrDocumentBody } from './shadowDomUtils';
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var useMountEffect = function useMountEffect(fn) {
  return React.useEffect(fn, []);
};
var useUpdateEffect = function useUpdateEffect(fn, deps) {
  var mounted = React.useRef(false);
  return React.useEffect(function () {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    return fn && fn();
  }, deps);
};
var useUnmountEffect = function useUnmountEffect(fn) {
  return React.useEffect(function () {
    return fn;
  }, []);
};
export var Portal = /*#__PURE__*/React.memo(function (props) {
  var _React$useState = React.useState(props.visible),
    mountedState = _React$useState[0],
    setMountedState = _React$useState[1];
  var rootElemRef = useRef(canUseDOM ? document.body : null);
  var container = props.container,
    id = props.id;
  useMountEffect(function () {
    if (!mountedState) {
      setMountedState(true);
      props.onMounted && props.onMounted();
    }
  });
  useUpdateEffect(function () {
    props.onMounted && props.onMounted();
  }, [mountedState]);
  useUnmountEffect(function () {
    props.onUnmounted && props.onUnmounted();
  });
  var element = props.element || props.children;
  if (element && mountedState) {
    var containerElement = typeof container === 'function' ? container() : container;
    var containerElementRoot = shadowOrDocumentBody(containerElement);

    // Look for existing target dom element to append to
    var existingParent = id && containerElementRoot.querySelector("#" + id);

    // Parent is either a new root or the existing dom element
    var parentElement = existingParent || containerElementRoot;
    rootElemRef.current = parentElement;
    if (rootElemRef.current != null) return /*#__PURE__*/createPortal(element, rootElemRef.current);
    return null;
  }
  return null;
});
export default Portal;